module.exports = __webpack_public_path__ + "static/media/img_Inscription_name1@2x.654f1aae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@2x/img_Inscription_name1@2x.png
// module id = 990
// module chunks = 0